// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Added the comments
// MODIFIED DATE : 17-09-2025

import futureDemandReportTypes from './future-demand-report.types';

/** ***************** FETCH FUTURE DEMAND COLLECTION REPORT DETAILS START *********************** */
export const fetchFutureDemandReportStart = (addData: any) => ({
	type: futureDemandReportTypes.FETCH_FUTURE_DEMAND_REPORT_START,
	payload: addData,
});

export const fetchFutureDemandReportSuccess = (successData: any) => ({
	type: futureDemandReportTypes.FETCH_FUTURE_DEMAND_REPORT_SUCCESS,
	payload: successData,
});

export const fetchFutureDemandReportFailure = (failureData: any) => ({
	type: futureDemandReportTypes.FETCH_FUTURE_DEMAND_REPORT_FAILURE,
	payload: failureData,
});

export const fetchFutureDemandReportResponseResetStart = () => ({
	type: futureDemandReportTypes.FETCH_FUTURE_DEMAND_REPORT_RESPONSE_RESET_START,
});

export const fetchFutureDemandReportResponseResetChanged = () => ({
	type: futureDemandReportTypes.FETCH_FUTURE_DEMAND_REPORT_RESPONSE_CHANGED,
});

/** ***************** FETCH FUTURE DEMAND COLLECTION REPORT DETAILS END *********************** */
